/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import PropTypes from 'prop-types';

export const alertActionModel = PropTypes.shape({
	id: PropTypes.string,
	label: PropTypes.string.isRequired,
	url: PropTypes.string,
});

export const alertModel = PropTypes.shape({
	id: PropTypes.string.isRequired,
	title: PropTypes.string,
	message: PropTypes.string.isRequired,
	action: alertActionModel,
}).isRequired;

export const sampleSimpleAlert = {
	id: '123',
	message: "Check out what's new",
};
export const sampleAlertwithTitle = {
	id: '123',
	title: 'New Release',
	message: "Check out what's new",
};
export const sampleAlertWithAction = {
	id: '123',
	title: 'New Release',
	message: "Check out what's new",
	action: {
		label: 'Go to release notes',
		url: 'http://www.ibm.com',
	},
};
export const sampleAlertWithEmptyAction = {
	id: '123',
	title: 'New Release',
	message: "Check out what's new",
	action: {
		label: '',
	},
};
export const sampleAlertWithEmptyLabelAction = {
	id: '123',
	title: 'New Release',
	message: "Check out what's new",
	action: {
		label: '',
		id: '111',
	},
};
export const sampleAlertWithActionById = {
	id: '123',
	title: 'New Release',
	message: "Check out what's new",
	action: {
		label: 'Go to release notes',
		id: 'openGlobalToast',
	},
};
